export default "__VITE_ASSET__CXAuuxGo__"